// eslint-disable react/no-unstable-nested-components
import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import {
  URL_SUPPORT,
  API_ADMIN_REQ_NORMATIVOS,
  ROW_COUNT,
  API_ADMIN_TIPO_AUDITORIA,
  API_ADMIN_GERENCIA,
  API_ADMIN_TIPO_UNIDAD_AUDITAR,
} from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import IGerencia from "../../../entities/IGerencia";
import { ITipoAuditoria } from "../../../entities/ITipoAuditoria";
import { ITipoUnidadAuditar } from "../../../entities/ITipoUnidadAuditar";
import IRequisitosNormativos from "../../../entities/IRequisitosNormativos";
import { createColumnHelper, CellContext } from "@tanstack/react-table";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import { cParamsActiveOrderNombre, cParamsActiveOrderTitle, cParamsPageSize } from "../../../helpers/paramsHelper";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
interface IRequisitosNormativosProps {
  cbGerencia?: Array<IGerencia>;
  cbTipoAuditoria?: Array<ITipoAuditoria>;
  cbTipoUnidad?: Array<ITipoUnidadAuditar>;
  items?: Array<any>;
  is_Test?: boolean;
}

const component = (titulo: string) => {
  return <RenderTitle title={titulo} />;
};

const componentValue = (value: any) => {
  return <RenderValue value={value} />;
};

const componentSearch = () => {
  return (
    <a href="#1" className="text-decoration-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
      <i className="bi bi-search"></i>
    </a>
  );
};

const RequisitosNormativos = ({ cbGerencia, cbTipoAuditoria, cbTipoUnidad, items, is_Test }: IRequisitosNormativosProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [comboGrc, setComboGrc] = useState<Array<IGerencia>>(cbGerencia || []);
  const [comboTA, setComboTA] = useState<Array<ITipoAuditoria>>(cbTipoAuditoria || []);
  const [comboTUA, setComboTUA] = useState<Array<ITipoUnidadAuditar>>(cbTipoUnidad || []);
  const [isLoading, setIsLoading] = useState(false);
  const [formAddEsParticular, setFormAddEsParticular] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = cParamsPageSize(pageSize);
    let result = is_Test
      ? { data: [], pages: 10 }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_REQ_NORMATIVOS}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    setListItems(list);
    params.PAGINADO = ROW_COUNT;
    let pages = result.pages;
    setPages(pages);

    const comboGrc = is_Test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)).result.data;
    setComboGrc(comboGrc);

    const comboTA = is_Test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderNombre)).result
          .data;
    setComboTA(comboTA);

    const comboTUA = is_Test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_UNIDAD_AUDITAR}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderNombre)).result
          .data;
    setComboTUA(comboTUA);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };
  const filter = (filter: Partial<IRequisitosNormativos>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }

    filter.TIPO_AUDITORIA = filter.ID_TIPO_AUDITORIA?.toString() || "";
    filter.GERENCIA = filter.ID_GERENCIA?.toString() || "";
    filter.UNIDAD_AUDITAR = filter.ID_UNIDAD_AUDITAR?.toString() || "";

    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }

    getAPI(`${URL_SUPPORT}${API_ADMIN_REQ_NORMATIVOS}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }
    if (value.ID_GERENCIA === 0) {
      delete value.ID_GERENCIA;
    }
    if (value.ID_UNIDAD_AUDITAR === 0) {
      delete value.ID_UNIDAD_AUDITAR;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_REQ_NORMATIVOS}`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID > 0);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columnHelperRequisitosNormativos = createColumnHelper<IRequisitosNormativos>();

  let columnDef = [
    columnHelperRequisitosNormativos.accessor("ID", {
      id: "ID",
      cell: (info: CellContext<IRequisitosNormativos, number>) => componentValue(info.getValue()),
      header: () => component("ID"),
      tipo: ITipo_Campo.key,
      title: "ID",
    } as any),
    columnHelperRequisitosNormativos.accessor((row) => row.TITULO, {
      id: "TITULO",
      cell: (info: CellContext<IRequisitosNormativos, string>) => componentValue(info.getValue()),
      header: () => component("Título"),
      tipo: ITipo_Campo.text,
      title: "Título",
      sorteditmode: 1,
      required: true,
    } as any),
    columnHelperRequisitosNormativos.accessor((row) => row.ID_MAESTRO, {
      id: "ID_MAESTRO",
      cell: (info: CellContext<IRequisitosNormativos, string>) => componentValue(info.getValue()),
      header: () => component("ID requisito normativo"),
      tipo: ITipo_Campo.text,
      title: "Id maestro requisito",
      sorteditmode: 3,
      required: true,
    } as any),
    columnHelperRequisitosNormativos.accessor((row) => row.ITEM, {
      id: "ITEM",
      cell: (info: CellContext<IRequisitosNormativos, string>) => componentValue(info.getValue()),
      header: () => component("Item"),
      tipo: ITipo_Campo.text,
      title: "Ítem",
      sorteditmode: 4,
      required: true,
    } as any),
    columnHelperRequisitosNormativos.accessor((row) => row.TIPO_AUDITORIA, {
      id: "ID_TIPO_AUDITORIA",
      cell: (info: CellContext<IRequisitosNormativos, string>) => componentValue(info.getValue()),
      header: () => component("Tipo auditoría"),
      tipo: ITipo_Campo.combo,
      title: "Tipo auditoría",
      sorteditmode: 2,
      required: true,
      callback: (id: string, value: number) => {
        const tipoAud = comboTA.filter((ta) => ta.ID === value)[0];
        setFormAddEsParticular(tipoAud.ES_GLOBAL || false);
      },
    } as any),
    columnHelperRequisitosNormativos.accessor((row) => row.GERENCIA, {
      id: "ID_GERENCIA",
      cell: (info: CellContext<IRequisitosNormativos, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia"),
      tipo: ITipo_Campo.combo,
      title: "Gerencia",
      sorteditmode: 5,
      hideColOnEdit: !formAddEsParticular,
    } as any),
    columnHelperRequisitosNormativos.accessor((row) => row.UNIDAD_AUDITAR, {
      id: "ID_UNIDAD_AUDITAR",
      cell: (info: CellContext<IRequisitosNormativos, string>) => componentValue(info.getValue()),
      header: () => component("Ámbito de auditoría"),
      tipo: ITipo_Campo.combo,
      title: "Ámbito de Auditoría",
      sorteditmode: 6,
      hideColOnEdit: !formAddEsParticular,
    } as any),
    columnHelperRequisitosNormativos.accessor((row) => row.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IRequisitosNormativos, boolean>) => componentValue(info.getValue() === true ? "Sí" : "No"),
      header: () => component("Activo"),
      tipo: ITipo_Campo.check,
      title: component("Activo"),
      sorteditmode: 7,
    } as any),
    columnHelperRequisitosNormativos.display({
      id: "editar",
      header: () => component("Editar"),
      cell: (props) => componentSearch(),
    }),
  ] as any;

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit({ ID: "", ID_GERENCIA: 0, ID_UNIDAD_AUDITAR: 0 }, {});
        }}></button>
      <AdminLista
        reload={filter}
        columnsDef={columnDef}
        items={[
          {
            type: "ID_TIPO_AUDITORIA",
            value: comboTA.map((ta) => {
              return { text: ta.NOMBRE, value: ta.ID };
            }),
          },
          {
            type: "ID_GERENCIA",
            value: comboGrc.map((csc) => {
              return { text: csc.TITULO, value: csc.ID };
            }),
          },
          {
            type: "ID_UNIDAD_AUDITAR",
            value: comboTUA.map((tua) => {
              return { text: tua.NOMBRE, value: tua.ID };
            }),
          },
        ]}
        callback={edit}
        data={listItems}
        tipo={"RequisitosNormativos"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Requisitos normativos"
        parentchild={(id: string, value: string) => {
          if (id === "ID_TIPO_AUDITORIA") {
            const tipoAud = comboTA.filter((ta) => ta.ID === value)[0];
            setFormAddEsParticular(tipoAud.ES_GLOBAL);
          }
        }}
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default RequisitosNormativos;
